import {request} from 'helpers/services/utils/request';
import {POST} from 'helpers/services/constants/API_CONSTANTS';
import {SEND_FLYERS_REQUEST} from 'helpers/services/constants/API_ENDPOINTS';

export const sendFlyersRequestApi = async (data) => {
  return request(POST, SEND_FLYERS_REQUEST(), {data});
};

export default sendFlyersRequestApi;
